import {Component, EventEmitter, Injector, Input, OnInit, Output} from "@angular/core";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {ParameterService} from "../../_services/parameter.service";
import {AddUserCertificationModal} from "../my-wallet/modals/add-user-certification.modal";
import {AdminService} from "../dashboard/services/admin.service";
import {CertService} from "../dashboard/services/cert.service";
import {InformationDialog} from "../../_shared/dialog/information.dialog";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";
import {AdminAddUserCertificationModal} from "./modals/add-user-certification.modal";

@Component({
    selector: 'admin-cert-wallet',
    templateUrl: './user-man-cert-wallet.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class UserManCertWalletComponent extends BasePageComponentDirective<any> implements OnInit {
    userCerts: any[] = [];
    attendanceTypes: any = {};
    @Output() getNumberCert = new EventEmitter();
    @Output() refreshCeuCredit = new EventEmitter();
    @Input() user:any;
    userId: any = null;
    certMax: any;
    totalCert = 0;
    constructor(
        injector: Injector,
        private adminService: AdminService,
        private certService: CertService,
        private parameterService: ParameterService,
    ) {
        super(injector);
    }
    query(): void {
        this.pageQuery.sortBy = 'id';
        this.pageQuery.sortOrder = 'desc';

        this.pageQuery.columns = ['certificationTitle'];
        this.adminService.getUserCertifications(this.pageQuery, this.userId).then(r => {
            this.userCerts = r.content;
            this.page.emit(r);
            this.getNumberCert.emit(this.totalRow);
            this.totalCert = this.totalRow;

        });
    }

    override async ngOnInit():Promise<void> {
        super.ngOnInit();
        this.attendanceTypes = await this.parameterService.getParameterByName("ATTENDANCE_TYPE");

        this.userId = this.activatedRoute.snapshot.params.id;
        this.certService.getLimitAdmin(this.userId).then(product => {
            this.certMax = product.certificateLimit;
        });
        this.query();

    }

    updateCertification(cert: any) {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(AdminAddUserCertificationModal, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                mode: 'edit',
                provider: cert.certification.association.id,
                title: cert.certification.title,
                id: cert.certification.id,
                acquiredDate: cert.acquiredDate,
                attendanceType: cert.attendanceType,
                providerAssignedId: cert.providerAssignedId,
                isAdmin: true,
                userId: this.user.id,
                earnedCertificationId: cert.id.id
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

    deleteCertification(cert: any) {
        const dialog = this.dialog.open(ConfirmationDialog, {
            data: {
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Delete',
                subMessage: `Are you sure want to delete user earned certification? it will also delete all CEU Credits related to the certification`,
                message: `Deletion of ${cert.certification.title}`,
                theme: 'dark'
            }
        })

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.certService.deleteCertification({
                    certificationId: cert.certification.id,
                    userId: this.userId,
                    earnedCertificationId: cert.id.id
                }).then(_ => {

                    this.query();
                    this.refreshCeuCredit.emit('refresh');

                    const screenWidth = window.innerWidth;
                    const dialogWidth = screenWidth < 768 ? '90vw' : '800px';

                    this.dialog.open(InformationDialog, {
                        width: dialogWidth,
                        maxWidth: '100%',
                        data: {
                            message: '',
                            subMessage: 'User earned certification and its CEU credits has been deleted successfully!',
                            theme: 'dark'
                        }
                    });


                })

            }
        })
    }

    checkAbilityToAddMore() {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        if(this.user && this.user.accountType != 'FREE') {
            if(this.totalCert >= this.certMax) {
                const confirm = this.dialog.open(ConfirmationDialog, {
                    width: dialogWidth,
                    maxWidth: '100%',
                    data: {
                        message: "Certification Limit reached",
                        subMessage: "this user reached limit to add new certification with current plan, click Ok, Continue to keep add new certification",
                        buttonOkLabel: 'Ok, Continue',
                        buttonCancelLabel: 'Cancel',
                        theme: 'dark'
                    }
                });
                confirm.componentInstance.result.subscribe(r => {
                    if(r) {
                        this.openModalAddCertification();
                    }
                })
            } else {
                this.openModalAddCertification();
            }
        }else {
            this.dialog.open(InformationDialog, {
                width: dialogWidth,
                maxWidth: '100%',
                data: {
                    theme: 'dark',
                    message: '',
                    subMessage: 'Your subscription type is FREE. Please upgrade your plan to upload more certifications. You can upgrade by clicking on Upgrade Plan menu'
                }
            });
        }

    }

    openModalAddCertification() {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const dialog = this.dialog.open(AdminAddUserCertificationModal, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                mode: 'new',
                isAdmin: true,
                userId: this.user.id,
                theme: 'dark'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.query();
            }
        })
    }

}
